// extracted by mini-css-extract-plugin
export default {"card":"Card_card__uXUjo","card__info":"Card_card__info__BVy5H"};